import React from 'react';

import styled from '@emotion/styled';

import { useAppSelector } from '../../redux/store';
import { getTimeOfDayGreeting } from '../../utils/utils';

interface PageLayoutProps {
  children?: any;
  noTitle?: boolean;
}

const PageLayout: React.FC<PageLayoutProps> = ({
  children,
  noTitle = false,
}) => {
  const { authData } = useAppSelector((state) => state.auth);

  return (
    <Container>
      {!noTitle && (
        <Title>
          {getTimeOfDayGreeting()}, {authData?.user?.firstName}{' '}
          {authData?.user?.lastName}.
        </Title>
      )}
      {children}
    </Container>
  );
};

export default PageLayout;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  /* border: 1px solid red; */
  padding: 20px;
`;

const Title = styled.div`
  font-size: 20px;
  font-weight: 500;
  color: #6b7280;
`;
